import { NavGroup } from '@makemydeal/dr-sales-checkin-types';
import { FEATURES } from '@makemydeal/dr-sales-checkin-types';

/** Nav groups rendered by the left nav (in order): "Build Your Offer" then "Quick Links". */
export const SIDE_NAV_GROUPS = [NavGroup.LeftNav, NavGroup.QuickLink] as const;

export const SEND_TO_DESK_NOTE = 'Sent to desk from Showroom';
export const SEND_TO_DESK_SUBMITTING_LABEL = 'Sending...';

export const Inventory = 'inventory';
export const RemoveCoBuyer = 'removeCoBuyer';
export const Cobuyer = 'cobuyer';
export const Deals = 'deal';
export const RecentDeals = 'recentDeals';
export const Username = 'username';
export const CobuyerInfo = 'cobuyerInfo';
export const Inbox = 'inbox';
export const CobuyerInbox = 'cobuyerInbox';
export const Tradein = 'tradein';
export const Finance = 'financing';
export const Insurance = 'insurance';
export const DealSummary = 'dealsummary';
export const VehicleDetails = 'vehicleDetails';
export const InventoryPath = 'inventory';
export const ShowroomPath = 'showroom';
export const ManageDocumentsPath = 'manageDocuments';
// Identifies Sales Check-In as the source app to the Digital Deal Jacket PBC.
export const DIGITAL_DEAL_JACKET_SOURCE = 'Retail360_Sales_Check_In';
export const NoDealershipPath = 'no-dealership-access';
export const DealershipPath = 'dealership-selector';
export const roleAssumptionPath = 'role-assumption';
export const applicationErrorPath = 'app-error';
export const DealSetupPath = 'deal-setup';
export const RootPath = '/';

export const CustomerCardConsumerInitialState = {
    consumerId: '',
    dealerGroupId: '',
    dealershipId: '',
    title: '',
    firstName: '',
    lastName: '',
    middleName: '',
    legalName: '',
    suffix: '',
    gender: '',
    maritalStatus: '',
    pronoun: '',
    note: '',
    homePhone: '',
    homePhoneExtension: '',
    workPhone: '',
    workPhoneExtension: '',
    cellPhone: '',
    cellPhoneExtension: '',
    primaryEmail: '',
    alternateEmail: '',
    street1: '',
    street2: '',
    street3: '',
    city: '',
    stateOrProvince: '',
    stateOrProvinceAbbreviation: '',
    postalCode: '',
    countyOrRegion: '',
    alternateIds: []
};

export const backdropExcludeClassesForSlideoutClose = [
    'k-child-animation-container',
    'interstate-reference',
    'MuiDialogActionns-root',
    'k-window',
    'MuiDialog-root',
    'MuiDialog-container',
    'MuiBackdrop-root',
    'MuiModal-root',
    'MuiPaper-root'
];

export const DEALERSHIP_MMDID = 'dealership.mmdid';
export const BACK_BTN_LABEL = 'Back to My Deal';

/** Host-app identifier passed to the shared UnifiedCustomerCard so it renders SCI-specific behaviour. */
export const HOST_APP = 'SCI';

/**
 * New Relic event emitted by `RemoteModuleErrorBoundary` when a Common Consumer Card remote fails
 * to render. Keep this name stable once dashboards reference it.
 *
 * SCI-prefixed deliberately, so Sales Check-in's remote failures are a distinct event stream from
 * dash's `MV:CCC:ModuleRenderError`. Note this means the existing "MV — Common Consumer Card
 * Integration Health" dashboard will NOT pick these up: its NRQL needs a new query (or an
 * `eventType` union) to cover SCI.
 */
export const REMOTE_MODULE_ERROR_EVENT = 'SCI:CCC:ModuleRenderError';

/**
 * Width of the customer-card slideout panel, matching dash's customer slideout: full-bleed below
 * `BreakPoints.DESKTOP` (992px) and a fixed 956px at/above it.
 *
 * TODO: needs to be revisited -- these values duplicate the literals dash hardcodes in
 * `libs/accelerate/dash-components/src/header/EditCustomerSlideout.tsx` (`newPanelWidth`).
 */
export const CUSTOMER_CARD_SLIDEOUT_PANEL_WIDTH_DESKTOP = '956px';
export const CUSTOMER_CARD_SLIDEOUT_PANEL_WIDTH_MOBILE = '100%';

/**
 * ShowroomLayout
 *
 * The available chrome variants the shared PageLayout shell can render.
 * - `SIDEBAR`: showroom-style layout with the left navigation.
 * - `BACK`: standalone page with a "Back to My Deal" button.
 */
export const ShowroomLayout = {
    SIDEBAR: 'sidebar',
    BACK: 'back'
};

export const TRADE_IN_OVERVIEW_TEST_ID = `section-placeholder-${FEATURES.TRADE_IN}`;

export const TRADE_IN_OVERVIEW_CONTENT = {
    heading: 'Trade-In Vehicle',
    description: 'Determine how much your current vehicle is worth, and apply that value to your new vehicle.',
    startLabel: 'Start Trade-In'
};

export const TRADE_IN_RECORD_CONTENT = {
    appraisalStatusLabel: 'Appraisal Status',
    mileageLabel: 'Mileage',
    estimatedValueLabel: 'Estimated value',
    payoffLabel: 'Pay-off',
    appraised: 'Appraised',
    pendingAppraisal: 'Pending appraisal',
    removeLabel: 'Remove',
    editLabel: 'Edit',
    emptyValue: '--'
};

export const REMOVE_TRADE_IN_MODAL_CONTENT = {
    title: 'Remove trade-in?',
    fallbackVehicleName: 'This trade-in',
    bodySuffix: 'will be removed from this deal, along with its estimated value. This can’t be undone.',
    cancelLabel: 'Cancel',
    confirmLabel: 'Remove'
};
